<template>
  <section class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <h3 class="footer-widget-title">about us</h3>
          <p class="widget_desc">
            Upskill is a peer to peer skill sharing platform. It enables
            individuals and organizations to share skills and exchange technical
            knowledge to bridge the skills gap in Bangladesh.
          </p>
          <a href="https://www.big.gov.bd/">
            <img
              src="../assets/images/BIG.png"
              style="max-width:170px; margin-bottom:10px"
              alt
            />
          </a>

          <br />
          <a href="https://bnia.basis.org.bd/win/winner-2018">
            <img src="../assets/images/footer/ict.png" alt />
          </a>
          <a href="https://www.startupbangladesh.vc/">
            <img
              class="mg-left-15"
              src="../assets/images/footer/startupbangladeshlogo.png"
              alt
            />
          </a>

          <a
            href="https://www.holoniq.com/notes/holoniq-india-southasia-edtech-100/"
          >
            <img
              class="mg-left-15-10"
              src="../assets/images/footer/holon.png"
              alt
            />
          </a>
        </div>
        <div class="col-md-2">
          <h3 class="footer-widget-title">Helpful Links</h3>
          <ul>
            <li>
              <a class="hover-link" @click="Goto({ name: 'faq' })">FAQ </a>
            </li>
            <li>
              <a class="hover-link" @click="Goto({ name: 'privacy' })"
                >Terms and Conditions</a
              >
            </li>
            <li>
              <a class="hover-link" @click="Goto({ name: 'privacy' })"
                >Privacy Statement</a
              >
            </li>
            <li>
              <a class="hover-link" @click="Goto({ name: 'about' })"
                >About Upskill</a
              >
            </li>
          </ul>
        </div>
        <!-- <div class="col-md-2">
          <h3 class="footer-widget-title">Follow Us</h3>
        <div id="social-follow"></div>
        </div> -->
        <div class="col-md-2">
          <h3 class="footer-widget-title">contact</h3>
          <p class="footer-address">
            <!-- <i class="fa fa-home"></i> -->
            56, A.H Tower (9th floor), <br />
            Road 2, Sector 3, Uttara 1230
          </p>
          <p class="footer-phone">
            <!-- <i class="fa fa-phone"></i> -->
            01714053213
          </p>
          <p class="footer-email">
            <!-- <i class="fa fa-envelope"></i> -->
            tasfia.upskill@gmail.com
          </p>
          <!-- <h4 class="footer-widget-title">Follow Us</h4>
          <div id="social-follow"></div> -->
        </div>
        <div class="col-md-4">
          <h3 class="footer-widget-title">Subscribe to our newsletter</h3>
          <div class="footer-newsletter">
            <div class="row">
              <div class="col-md-12">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Type your email"
                  v-model="email"
                  @keypress.enter="subscribe"
                />
              </div>
              <div class="col-md-12">
                <input
                  type="submit"
                  class="form-control"
                  placeholder="subscribe"
                  @click="subscribe"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      email: '',
    }
  },
  // mounted() {
  //   let linkedin = document.createElement('script')
  //   linkedin.setAttribute('type', 'IN/FollowCompany')
  //   linkedin.setAttribute('data-id', '14598438')
  //   linkedin.setAttribute('data-counter', 'bottom')
  //   document.getElementById('social-follow').appendChild(linkedin)
  // },
  methods: {
    subscribe() {
      this.$upskill
        .subscribe({ email: this.email })
        .then(() => {
          this.SuccessAlert('Successfully subscribed to the newsletter!')
        })
        .catch((err) => {
          this.ErrorAlert(err.data.message)
        })
    },
  },
}
</script>
<style scoped>
.form-control {
}
.mg-left-15 {
  margin-left: 20px;
}
@media screen and (min-width: 1300px) {
  .mg-left-15-10 {
    margin-left: 20px;
  }
}
@media screen and (max-width: 1232px) {
  .mg-left-15-10 {
    margin-left: -10px;
  }
}
</style>
